
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getWalletAddressLog } from '@/api/product/product'

@Component({
  name: 'walletAddressLog',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) id!: any
  @Prop() accountType!: any

  private walletAddressList: any = []
  private listLoading: boolean = false
  private total = 0

  private hashJump (row) {
    if (this.accountType === 'trc20') {
      window.open(`https://tronscan.io/#/address/${row.from_address}`)
    } else if (this.accountType === 'erc20') {
      window.open(`https://etherscan.io/address/${row.from_address}`)
    }
  }

  private hashJumpCurrent (row) {
    if (this.accountType === 'trc20') {
      window.open(`https://tronscan.io/#/address/${row.to_address}`)
    } else if (this.accountType === 'erc20') {
      window.open(`https://etherscan.io/address/${row.to_address}`)
    }
  }

  private hashJumpProductRef (row) {
    if (this.accountType === 'trc20') {
      window.open(`https://tronscan.io/#/transaction/${row.deposit_txn_id}`)
    } else if (this.accountType === 'erc20') {
      window.open(`https://etherscan.io/tx/${row.deposit_txn_id}`)
    }
  }

  private jump (row) {
    if (this.accountType === 'trc20') {
      window.open(row.transaction_url)
    } else if (this.accountType === 'erc20') {
      window.open(row.transaction_url)
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange (size) {
    this.pagesize = size
    this.getWalletAddressLog()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange (currentPage) {
    this.currentPage = currentPage
    this.getWalletAddressLog()
  }

  // 获取钱包地址归集列表
  private async getWalletAddressLog () {
    try {
      this.listLoading = true
      let params: any = {
        id: this.id,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await getWalletAddressLog(params).then((res: any) => {
        this.walletAddressList = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  created () {
    this.getWalletAddressLog()
  }
}
